import { useTheme } from '@emotion/react';
import { Box, FormControlLabel, Grid, Radio, Typography, Stack } from '@mui/material';
import { FormEventHandler, FC, FunctionComponent } from 'react';

type RebookingChoicesRadioProps = {
    label: string;
    description: string;
    icon?: FunctionComponent<React.SVGProps<SVGSVGElement> & { title?: string }>;
    value: string;
    checked: boolean;
    onChange: FormEventHandler;
};

export const RebookingChoicesRadio: FC<RebookingChoicesRadioProps> = ({
    checked,
    value,
    onChange,
    label,
    description,
    icon: Icon,
}) => {
    const theme = useTheme();
    return (
        <Stack
            rowGap="8px"
            px="16px"
            py="16px"
            border="1px solid"
            borderColor={checked ? 'primary.main' : theme.palette.grey[300]}
            onClick={(e) => onChange(e)}
            sx={{
                cursor: 'pointer',
                '&:hover': {
                    borderColor: 'text.secondary',
                },
            }}
            width="100%"
            height="100%"
        >
            <Grid container justifyContent="space-between">
                <Grid item>
                    <FormControlLabel
                        checked={checked}
                        control={<Radio />}
                        label={<Typography variant="h3">{label}</Typography>}
                        value={value}
                    />
                </Grid>

                {Icon && (
                    <Grid
                        item
                        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                    >
                        <Box
                            p="3px"
                            width="32px"
                            height="32px"
                            sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                        >
                            <Icon
                                fontSize={200}
                                css={{ fill: theme.palette.grey[300] }}
                                height="18px"
                            />
                        </Box>
                    </Grid>
                )}
            </Grid>
            <Typography variant="body2">{description}</Typography>
        </Stack>
    );
};
